export default "__VITE_PUBLIC_ASSET__03b6c222__"